module.exports = __webpack_public_path__ + "static/brands-613a5b29f4d46ddefb5681dc397e4119.jpg";